<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="201" v-if="showInfo"></v-overlay>
    </transition>
    <v-dialog
      :value="showInfo"
      persistent
      max-width="600px"
      scrollable
      hide-overlay
    >
      <v-card class="unmarkable">
        <v-card-title>
          <div class="titleBar">
            <div class="header">
              <v-icon>
                info
              </v-icon>
              <div>
                &nbsp; Info
              </div>
            </div>
            <div v-if="version">
              {{ version }}
            </div>
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h2 align="left">Commands</h2>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Icon</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="removeRowSelection"
                v-for="(item, index) in editIcons"
                :key="index"
              >
                <td align="left">
                  <v-icon>
                    {{ item.icon }}
                  </v-icon>
                </td>
                <td align="left">{{ item.description }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-divider></v-divider>
          <div :style="{ height: '20px' }"></div>
          <h2 align="left">Drives</h2>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Icon</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="removeRowSelection"
                v-for="(drive, index) in drives"
                :key="index"
              >
                <td align="left">
                  <img
                    :src="drive.imagePath"
                    :alt="drive.name"
                    :style="{ height: '2em' }"
                    class="centerImg"
                  />
                </td>
                <td align="left">
                  {{ drive.displayName }} {{ drive.additionalDescription }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary darken-1" text @click="closeInfo"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TOGGLE_SHOW_INFO } from "../../store/modules/showComponents/constants";
import { pickTypesSettings } from "../utils/tableEditorHeaderHelper.js";
const _ = require("lodash");

function EditItem(icon, description) {
  this.icon = icon;
  this.description = description;
}

export default {
  name: "InfoComponent",

  data: function() {
    return {
      editIcons: [
        new EditItem("cloud_download", "Load a file from the server"),
        new EditItem("cloud_upload", "Save a file to the server"),
        new EditItem("add", "Create a new pattern"),
        new EditItem("fullscreen", "Fullscreen mode"),
        new EditItem("fullscreen_exit", "Exit fullscreen mode"),
        new EditItem("find_replace", "Reset zoom"),
        new EditItem("zoom_out", "Zoom out"),
        new EditItem("zoom_in", "Zoom in"),
        new EditItem("info", "Open info for icons"),
        new EditItem("settings", "Open settings"),
        new EditItem("border_color", "Edit selected cells"),
        new EditItem("content_copy", "Copy selection"),
        new EditItem("content_paste", "Paste copied values"),
        new EditItem("layers_clear", "Empty selection"),
        new EditItem("$vuetify.icons.jumpToPick", "Jump to a specific pick"),
        new EditItem("$vuetify.icons.editPicks", "Edit picks"),
        new EditItem("$vuetify.icons.editDrives", "Edit drives")
      ]
    };
  },

  computed: {
    showInfo() {
      return this.$store.state.showComponents.showInfoComponent;
    },
    drives() {
      const drives = [];
      _.forEach(pickTypesSettings, t => {
        if (t.displayName) {
          drives.push(t);
        }
      });
      return drives;
    },
    version() {
      if (process.env.VUE_APP_VERSION) {
        return `Version ${process.env.VUE_APP_VERSION}`;
      } else {
        return null;
      }
    }
  },

  methods: {
    closeInfo() {
      this.$store.dispatch(TOGGLE_SHOW_INFO);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.removeRowSelection {
  background: none !important;
}

.centerText {
  margin-bottom: 5px;
  font-size: 120%;
}

.header {
  display: flex;
}

.titleBar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
